import { render, staticRenderFns } from "./MyProfileAddressProof.vue?vue&type=template&id=a78d3144"
import script from "./MyProfileAddressProof.vue?vue&type=script&lang=js"
export * from "./MyProfileAddressProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports